import { Notification } from "../../global-components/src/types";
import { BUCKET_PACOCA_URL } from "../../global-components/src/utils/vars";
import { useTheme } from "../../global-components/src";
import { Icon } from "../../global-components/src/components/icon";
import { BadgeCheck, Cake, DollarSign, Eye, Heart, LockKeyhole, Megaphone, MessageCircle, MessageSquareText, Shield, TextAlignJustify, UserMinus, UserPlus, Users, Wallet } from "lucide-react";
import { getImageUser, getImageUserNotFound } from "../../global-components/src/utils/auth";
interface Props{
    notification: Notification
}

export const NotificationIcon = ({ notification }: Props) => {
    const { isDarkMode } = useTheme();

    const getIcon = (name: string) => {
        const icon = name.replace("icon_", "");

        return (
            <>
                <div className="icon-notification user-select-none">
                    <Icon className='menu-father-icon' invertColor={!isDarkMode} name={icon} size={35}>
                        {getIconLucide(name)}
                    </Icon>
                </div>
            </>
        )
    };
    
    const getIconLucide = (name: string) => {
        const icon = name.replace("icon_", "");

        if(icon === "celebration")
            return <Cake/>
        
        if(icon === "attach_money")
            return <DollarSign/>
        
        if(icon === "admin_panel_settings")
            return <Shield/>
        
        if(icon === "verified")
            return <BadgeCheck/>
        
        if(icon === "campaign")
            return <Megaphone/>

        if(icon === "lock_person")
            return <LockKeyhole/>

        if(icon === "group")
            return <Users/>

        return <Wallet/>
    };

    const getIconImage = (notification: Notification) => {
        if(notification.text.includes("parabéns") || notification.text.includes("parabenizou") || notification.text.includes("aniversário")){
            return "celebration";
        }
        if(notification.text.includes("R$")){
            return "celebration";
        }
        if(notification.text.includes("te enviou 1 paçoquinhas")){
            return "attach_money";
        }

        switch (notification.type) {
            case "1":
                return 'chat';

            case "2":
                return 'post';
            
            case "3":
                return 'mail';
            
            case "4":
                return 'favorite';
            
            case "5":
                return 'favorite';
            
            case "6":
                return 'post';

            case "7":
                return 'person_search';

            case "8":
                return 'post';

            case "9":
                return 'visibility';

            case "10":
                return 'attach_money';
            
            case "11":
                return 'person_cancel';

            case "20":
                return 'chat';

            case "21":
                return 'favorite';
            
            default: null
        }
    }
    const getIconImageLucide = (notification: Notification) => {
        if(notification.text.includes("parabéns") || notification.text.includes("parabenizou") || notification.text.includes("aniversário")){
            return <Cake size={13} />;
        }
        if(notification.text.includes("R$")){
            return <Cake size={13} />;
        }
        if(notification.text.includes("te enviou 1 paçoquinhas")){
            return <DollarSign size={13} />;
        }

        switch (notification.type) {
            case "1":
                return <MessageSquareText size={13} />;

            case "2":
                return <TextAlignJustify size={13} />;
            
            case "3":
                return <MessageSquareText size={13} />;
            
            case "4":
                return <Heart size={13} />;
            
            case "5":
                return <Heart size={13} />;
            
            case "6":
                return <TextAlignJustify size={13} />;

            case "7":
                return <UserPlus size={13} />;

            case "8":
                return <TextAlignJustify size={13} />;

            case "9":
                return <Eye size={13} />;

            case "10":
                return <DollarSign size={13} />;
            
            case "11":
                return <UserMinus size={13} />;

            case "20":
                return <MessageSquareText size={13} />;

            case "21":
                return <Heart size={13} />;
            
            default: null
        }
    }

    const getNotificationType = (number: string) => {
        switch (number) {
            case "1":
                return 'comment';

            case "2":
                return 'repostPost';
            
            case "3":
                return 'chat';
            
            case "4":
                return 'likePost';
            
            case "5":
                return 'likeComment';
                break;
            
            case "6":
                return 'mention';

            case "7":
                return 'follow';

            case "8":
                return 'responseComment';

            case "9":
                return 'viewProfile';

            case "10":
                return 'transfer_received';

            case "11":
                return 'unfollow';

            case "20":
                return 'comment';

            case "21":
                return 'likePost';
            
            default:
                return null;
        }
    }

    return (
        <>
            {!notification.img_notification.startsWith("icon_") ? (
                <div style={{ position: "relative", height: 50 }}>
                    <img 
                        className={`border-notification border-notification-${getNotificationType(notification.type)} user-select-none col-1 img-list-notification`} 
                        src={getImageUser(notification.img_notification, undefined, notification.text.includes("@") ? notification.text.replace("@", "")[0] : notification.text[0])} 
                        onError={(e) => { e.currentTarget.src = getImageUserNotFound(notification.text.includes("@") ? notification.text.replace("@", "")[0] : notification.text[0]); }}
                    />

                    {getIconImage(notification) && (
                        <div className={`badge-icon-notification user-select-none ${getIconImage(notification)}`}>
                            <Icon className="badge-icon-notification" invertColor={!isDarkMode} name={getIconImage(notification)} size={35}>
                                {getIconImageLucide(notification)}
                            </Icon>
                        </div>
                    )}
                </div>
            ): (
                <>{getIcon(notification.img_notification)}</>
            )}
        </>
    );
}